export default function LoadingBox() {
  return (
    <div className="row center">
      <img className="loading" src="/images/animation.gif" alt="LOADING"></img>
    </div>
  );
}
